import { useState, useEffect, Fragment } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import ExamTimer from "./ExamTimer";
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});

const StatusBar = (props) => {
  // const [progress, setProgress] = useState(50)

  //     useEffect(() => {
  //         setTimeout(() => {
  // setProgress(100)
  //         }, 1000)
  //     }, [])

  return (
    <div className="StatusBar col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div className="StatusBar_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div className="info col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          {props.allQuestions > 0 && (
            <p className="question_status text">
              {props.activeQuestion + " از " + props.allQuestions}
            </p>
          )}
          <p className="time_left text">
            {props.exam_time > 0 && (
              <ExamTimer
                time={props.exam_time}
                enable_lockMode={() => props.enable_lockMode()}
              />
            )}
          </p>
        </div>
        <div className="Status_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ThemeProvider theme={theme}>
            <LinearProgress
              variant="determinate"
              value={
                props.allQuestions === 0
                  ? 0
                  : Math.round(
                      (props.activeQuestion * 100) / props.allQuestions
                    )
              }
            />
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;
